import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Futura Condensed Extra Bold';
    src: url('https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-gti50/futura/Futura-CondensedExtraBold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }
    
` as unknown as React.FC; // 👈 forzamos el tipo para JSX
